import { performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

export const getAuthURIService = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getAuthURI}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const getDisconnectQB = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getAuthURI}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&disconnect_qb=true`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const quickBooksCallback = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.quickBookCallback}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data, '', true, true);
};
